import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="header-nav">
      <div className="container flex justify-between items-center h-full">
        <div className="font-mono text-lg font-semibold" style={{ color: 'var(--text-primary)' }}>
          aithatwows.com
        </div>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <a href="/" className="body-small hover:opacity-70 transition-opacity">
            Home
          </a>
          <a href="#agents" className="body-small hover:opacity-70 transition-opacity">
            Agents
          </a>
          <a href="#timeline" className="body-small hover:opacity-70 transition-opacity">
            Timeline
          </a>
          <a href="#guarantees" className="body-small hover:opacity-70 transition-opacity">
            Guarantees
          </a>
          <a href="#contact" className="body-small hover:opacity-70 transition-opacity">
            Contact
          </a>
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex nav-actions">
          <button className="btn-secondary" onClick={() => navigate('/login')}>
            Login
          </button>
          <button className="btn-primary" onClick={() => navigate('/checkout?plan=professional')}>
            Get Started
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          style={{ color: 'var(--text-primary)' }}
        >
          {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full" style={{ 
          background: 'var(--bg-overlay)', 
          backdropFilter: 'blur(8px)' 
        }}>
          <div className="container py-4 flex flex-col gap-4">
            <a href="/" className="body-small hover:opacity-70 transition-opacity">
              Home
            </a>
            <a href="#agents" className="body-small hover:opacity-70 transition-opacity">
              Agents
            </a>
            <a href="#timeline" className="body-small hover:opacity-70 transition-opacity">
              Timeline
            </a>
            <a href="#guarantees" className="body-small hover:opacity-70 transition-opacity">
              Guarantees
            </a>
            <a href="#contact" className="body-small hover:opacity-70 transition-opacity">
              Contact
            </a>
            <div className="flex flex-col gap-2 mt-4">
              <button className="btn-secondary" onClick={() => navigate('/login')}>
                Login
              </button>
              <button className="btn-primary" onClick={() => navigate('/checkout?plan=professional')}>
                Get Started
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;